import { render } from "@/components/pages/individualWorkSupport/requirement106/Requirement106.html?vue&type=template&id=32cdeb66&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement106/Requirement106.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement106/Requirement106.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement106/Requirement106.scss?vue&type=style&index=0&id=32cdeb66&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cdeb66"]])

export default __exports__